import { useGateValue } from "@statsig/react-bindings";
import { useMemo } from "react";

import { interlude } from "@/interlude";

/**
 * Check if Billing V2 is enabled for the current org.
 *
 * Requires BOTH:
 * 1. Statsig feature gate "enable_billing_v2" → on
 * 2. GET /migration-status returns isNewBilling: true
 *
 * If the API returns BILLING_NOT_CONFIGURED (404), isEnabled = false
 * → BillingPageWrapper shows old billing page (redirect behavior).
 */
export const useEnableBillingV2 = () => {
  const gateValue = useGateValue("enable_billing_v2");

  const migrationQuery = interlude.billing.useGetMigrationStatus(undefined, {
    enabled: gateValue,
  });

  return useMemo(
    () => ({
      isEnabled: gateValue && (migrationQuery.data?.isNewBilling ?? false),
      isPending: gateValue && migrationQuery.isPending,
    }),
    [gateValue, migrationQuery.data?.isNewBilling, migrationQuery.isPending],
  );
};
